import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.ts';
import { Boton } from './ui.tsx';

interface Campania {
  id: string;
  titulo: string;
  mensaje: string;
  imagenUrl: string | null;
  descuentoPct: number | null;
  ctaTexto: string | null;
  ctaUrl: string | null;
}

/** Pop-up de campaña al entrar (SPEC §6.1). Marca la vista para respetar soloUnaVez. */
export function PopupCampania() {
  const [cerrada, setCerrada] = useState(false);
  const activa = useQuery({
    queryKey: ['campania-activa'],
    queryFn: () => api<{ campania: Campania | null }>('/campanias/activa'),
    staleTime: Infinity,
  });

  const campania = activa.data?.campania;
  if (!campania || cerrada) return null;

  function cerrar() {
    setCerrada(true);
    void api(`/campanias/${campania!.id}/vista`, { metodo: 'POST' }).catch(() => undefined);
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-label={campania.titulo}
    >
      <div className="tarjeta w-full max-w-sm overflow-hidden shadow-[var(--sombra-alta)]">
        {campania.imagenUrl ? (
          <img src={campania.imagenUrl} alt="" className="max-h-64 w-full object-cover" />
        ) : null}
        <div className="space-y-3 p-5">
          <h2 className="text-[22px] font-light">
            {campania.titulo}
            {campania.descuentoPct !== null ? (
              <span
                className="ml-2 rounded-full px-2.5 py-0.5 align-middle text-sm font-medium"
                style={{ backgroundColor: 'var(--color-acento-var)', color: 'var(--color-acento-texto)' }}
              >
                -{campania.descuentoPct}%
              </span>
            ) : null}
          </h2>
          <p className="text-sm text-suave">{campania.mensaje}</p>
          <div className="flex justify-end gap-2">
            {campania.ctaUrl ? (
              <a
                href={campania.ctaUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={cerrar}
                className="inline-flex min-h-11 items-center rounded-full px-5 text-sm font-medium"
                style={{ backgroundColor: 'var(--boton-bg)', color: 'var(--boton-texto)' }}
              >
                {campania.ctaTexto ?? 'Ver más'}
              </a>
            ) : null}
            <Boton variante="secundario" onClick={cerrar}>
              Cerrar
            </Boton>
          </div>
        </div>
      </div>
    </div>
  );
}
